import styled from 'styled-components'

export const Div = styled.div`
  padding: 1rem;
`
